import {
  WbAlert,
  WbCardContent,
  WbTabPanel,
} from '@agilelab/plugin-wb-platform';
import { FC } from 'react';
import { useTeamRolesPanelContext } from '../../../context';
import { TeamRoleAssignmentsTable } from './TeamRoleAssignmentsTable';
import {
  ownerTeamRole,
  TeamRoleEnum,
} from '@agilelab/plugin-wb-team-roles-common';
import { CreateTeamRoleAssignmentDrawer } from '../CreateTeamRoleAssignmentDrawer';

export const TeamRoleAssignmentsCard: FC = () => {
  const {
    selectedTeamRole,
    hasMultiplePrincipalOwners,
    hasTroubleshootAccess,
    isOwner,

    enabledTeamRoles,
    openCreateTeamRoleAssignmentDrawer,
    setOpenCreateTeamRoleAssignmentDrawer,
  } = useTeamRolesPanelContext();

  return (
    <>
      {enabledTeamRoles.map((_role, index) => (
        <WbTabPanel key={index} index={index}>
          <WbCardContent style={{ height: '100%' }}>
            {selectedTeamRole === TeamRoleEnum.OWNER && (
              <>
                {hasMultiplePrincipalOwners && (
                  <WbAlert
                    style={{ marginBottom: 16 }}
                    variant="collapsible"
                    message={{
                      title: `Multiple Full ${ownerTeamRole.displayName}s detected`,
                      type: 'warning',
                      content:
                        hasTroubleshootAccess || isOwner
                          ? 'Having multiple Full Owners creates ambiguity. Witboost cannot determine which one to write into the project descriptor, so the descriptor may be out of sync with what is configured here. To resolve this, keep exactly one Full Owner.'
                          : 'Multiple Full Owners create ambiguity that may cause the project descriptor to be out of sync with Team Roles settings. Please contact a Full Owner or the Platform Team to resolve this.',
                    }}
                  />
                )}
              </>
            )}
            <TeamRoleAssignmentsTable />
          </WbCardContent>
        </WbTabPanel>
      ))}
      <CreateTeamRoleAssignmentDrawer
        open={openCreateTeamRoleAssignmentDrawer}
        setOpen={setOpenCreateTeamRoleAssignmentDrawer}
      />
    </>
  );
};
